module.exports = __webpack_public_path__ + "static/media/checkbox-unchecked-32.3152f268.svg";